import React, { useState } from 'react';
import LogoComponent from '../../components/generic-components/LogoComponent';
import API from '../../API';

const EmailExpired = () => {
  const [message, setMessage] = useState('');

  const handleVerfyEmail = async () => {
    await API.get('email/resend').then(res => {
      setMessage(res.msg);
    }).catch(err => {
      setMessage(err.msg);
    });
  };
  
  return (
    <div className="col px-md-5 py-3 pb-5 background_dark"> 
      <div className="d-flex justify-content-center border-bottom border-bottom-dark py-3">
        <LogoComponent />
      </div>
      <div className="email-expired-content">
        <h1 className="email-expired-title">Email verification link expired</h1>
        <p className="email-expired-text">Looks like the verification link has expired. Not to worry, we can send the link again.</p>
      </div>
      {message?.length > 0 && <p className={`${message.length > 40 ? 'text-green' : 'text-red'} d-flex justify-content-center font-weight-bold font-size-12 py-3`}>{message}</p>}
      <div className="d-flex justify-content-center">
        <button onClick={handleVerfyEmail} className="d-flex justify-content-center align-items-center button-container border-radius-button mt-5 mb-2 btn-gradient custom-sign-in-btn ">
          Resend verification link
        </button>
      </div>
    </div>
  );
};

export default EmailExpired;
